import * as React from 'react';

// !error: need to find a way get tailwind breakpoint
export const desktop = '(min-width: 640px)';

export function useMediaQuery(query: string, defaultValue = false) {
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = window.matchMedia(query);
    result.addEventListener('change', onChange);
    setValue(result.matches);

    return () => result.removeEventListener('change', onChange);
  }, [query]);

  return value;
}
